import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState } from '@mews-commander/types';
import { getResourceNameWithCategoryDetail } from '@mews-commander/legacy-entities/src/selectors/resources';

interface StateProps {
    resourceName: string;
}

interface OwnProps {
    resourceId: string;
    serviceId: string;
}

export const connectSpaceOrderName = connect<StateProps, null, OwnProps, ApplicationState>(
    createStructuredSelector({
        resourceName: getResourceNameWithCategoryDetail,
    })
);
